import { css } from '@emotion/react'
import { DataTableRenderProps, PagedTable, PagedTableProps } from 'bold-ui'
import { AccordionDataTable } from 'components/accordion/accordion-data-table/AccordionDataTable'
import { TableBox } from 'components/table'
import { VisualizarPaginaButton } from 'components/VisualizarPaginaButton'
import { useServerTime } from 'hooks/useServerTime'

import { BuscaCidadaoQueryResultModel } from '../../model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'
import { AcompanhamentoCondicaoSaudeAccordionPanel } from '../accordion/AcompanhamentoCondicaoSaudeAccordionPanel'
import {
  InfoCpfCnsAcompanhamentoCondicaoSaude,
  renderUltimasMedicoes,
  renderUltimoAtend,
} from './render-acompanhamentoCondicaoSaudeColumns'

interface AcompanhamentoCondicaoSaudeTableSelectorProps
  extends Omit<PagedTableProps<BuscaCidadaoQueryResultModel>, 'columns'> {
  hasIvcfFilter?: boolean
}

export const AcompanhamentoCondicaoSaudeTable = (props: AcompanhamentoCondicaoSaudeTableSelectorProps) => {
  const { ...tableProps } = props
  const { getServerTimeNow } = useServerTime()

  return (
    <TableBox>
      <PagedTable<BuscaCidadaoQueryResultModel>
        {...tableProps}
        render={(renderProps: DataTableRenderProps) => (
          <AccordionDataTable
            {...renderProps}
            components={{
              AccordionPanel: AcompanhamentoCondicaoSaudeAccordionPanel,
            }}
          />
        )}
        columns={[
          {
            name: 'cidadao',
            header: 'Identificação',
            sortable: true,
            render: (row) => <InfoCpfCnsAcompanhamentoCondicaoSaude row={row} />,
            style: css`
              width: 31%;
            `,
          },
          {
            name: 'ultimosAtendimentos',
            header: 'Últimos atendimentos',
            sortable: false,
            render: (row) => renderUltimoAtend(row, getServerTimeNow),
            style: css`
              width: 31%;
              padding: 1rem;
            `,
          },
          {
            name: 'ultimasMedicoes',
            header: 'Últimas medições',
            sortable: false,
            render: renderUltimasMedicoes,
            style: css`
              width: 38%;
            `,
          },
          {
            name: 'visualizarCadastro',
            header: '',
            render: (row: BuscaCidadaoQueryResultModel) => (
              <VisualizarPaginaButton
                path={`/cidadao/${row.cidadaoId}/informacoes`}
                tooltipText='Visualizar cadastro'
              />
            ),
            style: css`
              width: 60px;
              margin-right: 10px;
            `,
          },
        ]}
      />
    </TableBox>
  )
}
